import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { UntilDestroy } from '@ngneat/until-destroy';

import { TicketType } from '@shared/enums/ticket-type';
import { InputModule } from '@ui-components/controls/input/input.module';

@UntilDestroy()
@Component({
  standalone: true,
  selector: 'app-create-board-column-modal',
  templateUrl: './create-board-column-modal.component.html',
  styleUrls: ['./create-board-column-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, ReactiveFormsModule, MatDialogModule, InputModule, MatButtonModule],
})
export class CreateBoardColumnModalComponent {
  private formBuilder: FormBuilder = inject(FormBuilder);
  public data: { boardName: string; ticketType: TicketType } = inject(MAT_DIALOG_DATA);
  public dialogRef: MatDialogRef<CreateBoardColumnModalComponent> = inject(MatDialogRef);

  form = this.formBuilder.group({
    columnName: [null, [Validators.required]],
  });

  formSubmitted = false;

  ok() {
    this.formSubmitted = true;
    this.form.markAllAsTouched();
    if (this.form.invalid) return;

    this.dialogRef.close(this.form.value);
  }

  close() {
    this.dialogRef.close();
  }
}
